<template>
  <el-dialog
    class="rc-dialog"
    title="审核"
    :visible.sync="auditInfo.flag"
    :close-on-click-modal="false"
    @close="close(false)"
    destroy-on-close
    width="50%"
  >
    <el-form
      :model="ruleForm"
      ref="rForm"
      label-width="170px"
      class="ruleForm"
      size="small"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="审核意见："
            prop="auditSchedule"
            :rules="[{ required: true, message: '请选择审核意见' }]"
          >
            <el-radio-group
              v-model="ruleForm.auditSchedule"
              @input="radioChange"
            >
              <el-radio
                v-for="(item, i) in auditScheduleAttr.slice(1, 3)"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.auditSchedule === '1'">
        <el-col>
          <el-form-item label="驳回原因：" prop="auditContent">
            <el-input
              type="textarea"
              placeholder="请输入驳回原因"
              :row="4"
              maxlength="200"
              show-word-limit
              v-model="ruleForm.auditContent"
              @input="contentChange"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="短信通知申请人："
            prop="auditPerson"
          >
            <el-checkbox v-model="ruleForm.auditPerson">{{
              ruleForm.createUserName
            }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.auditPerson">
        <el-col>
          <el-form-item label="消息内容：" :rules="[{ required: true }]">
            <el-input
              v-model="ruleForm.auditMessage"
              type="textarea"
              :row="2"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="ruleForm.auditSchedule !== '1'">
        <el-row>
          <el-col>
            <el-form-item
              label="短信通知被转让用户："
              prop="transferPerson"
            >
              <el-checkbox v-model="ruleForm.transferPerson">{{
                ruleForm.moveUserName
              }}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.transferPerson">
          <el-col>
            <el-form-item label="消息内容：" :rules="[{ required: true }]">
              <el-input
                v-model="ruleForm.transferMessage"
                type="textarea"
                :row="2"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="close(false)" title="取消"></butn>
      <butn btntype="primary" @click="updateForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>
<script>
import { auditTransferUpdate } from "@/api/moveAudit";
import { getSmsTemplate } from "@/api/sysParam.js";
import butn from "@/components/button/index";
import { getEnums } from "@/utils/common.js";
import Bus from "./Bus.js";

export default {
  components: { butn },
  props: {
    auditInfo: {
      type: Object,
      default: function() {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      ruleForm: {
        auditSchedule: "2",
        auditContent: "",
        auditPerson: true,
        transferPerson: true,
        auditMessage: "",
        transferMessage: "",
      },
      auditScheduleAttr: [],
      smsList: [],
    };
  },
  methods: {
    // 确定
    updateForm() {
      this.$refs["rForm"].validate((valid) => {
        if (valid) {
          this.fetchUpdate();
        }
      });
    },

    fetchUpdate(forceAuditFlag = 0) {
      let params = {
        ...this.auditInfo,
        auditSchedule: this.ruleForm.auditSchedule,
        auditContent: this.ruleForm.auditContent,
        forceAuditFlag,
      };
      // 删除无用数据
      delete params["createUserName"];
      delete params["moveUserName"];
      delete params["userName"];
      delete params["deptRoleName"];
      delete params["flag"];
      // 组装smsTypes
      let smsTypes = [];
      // 不同意
      if (this.ruleForm.auditSchedule === "1") {
        if (this.ruleForm.auditPerson) {
          smsTypes.push({
            smsType: 3,
            smsContent: this.ruleForm.auditMessage,
          });
        }
      } else {
        //同意
        if (this.ruleForm.auditPerson) {
          smsTypes.push({
            smsType: 1,
            smsContent: this.ruleForm.auditMessage,
          });
        }
        if (this.ruleForm.transferPerson) {
          smsTypes.push({
            smsType: 2,
            smsContent: this.ruleForm.transferMessage,
          });
        }
      }
      params.smsTypes = smsTypes;
      auditTransferUpdate(params).then((res) => {
        if (res.code === 0) {
          const { success, msg } = res.data;
          if (success) {
            this.$message.success(res.msg);
            this.close(true);
          } else {
            this.$confirm(
              `被转让用户已经有同一管理组织的角色权限【${msg}】,确认要审核通过吗？<br/><br/>通过后转让用户的该角色权限将被删除，<br/>被转让用户不获得该角色权限。`,
              "系统提示",
              {
                dangerouslyUseHTMLString: true,
                type: "warning",
                confirmButtonText: "确认",
                cancelButtonText: "取消",
              }
            )
              .then(() => {
                this.fetchUpdate(1);
              })
              .catch(() => {});
          }
        }
      });
    },

    /**
     * 驳回原因
     */
    contentChange(text) {
      if (text && text.length > 0) {
        this.ruleForm.auditMessage = this.smsList[2].replace(
          "{auditContent}",
          text
        );
      } else {
        this.ruleForm.auditMessage = this.smsList[2].replace(
          "，驳回原因：{auditContent}",
          ""
        );
      }
    },
    // 审核意见
    radioChange(e) {
      if (this.smsList.length != 3) {
        this.getSms();
      } else {
        this.changeSms(e);
      }
    },

    changeSms(val) {
      if (val == 1) {
        // 不同意
        this.contentChange(this.ruleForm.auditContent);
      } else {
        this.ruleForm.auditMessage = this.smsList[0];
        this.ruleForm.transferMessage = this.smsList[1];
      }
    },

    // 关闭
    close(refreshFlag = false) {
      this.$emit("close", refreshFlag);
    },

    getSms() {
      getSmsTemplate("1,2,3").then((res) => {
        if (res && res.code == 0) {
          let list = res.data || [];
          list = list.map((sms) => {
            sms = sms.replace("{userName}", this.auditInfo.userName);
            sms = sms.replace("{deptRoleName}", this.auditInfo.deptRoleName);
            sms = sms.replace("{moveUserName}", this.auditInfo.moveUserName);
            return sms;
          });
          this.smsList = list;

          if (list.length > 2) {
            this.changeSms(this.ruleForm.auditSchedule);
          }
        }
      });
    },
  },
  created() {
    getEnums(["AUDIT_SCHEDULE"], this, ["auditScheduleAttr"], [false]);
    this.getSms();
    this.ruleForm.createUserName = this.auditInfo.createUserName;
    this.ruleForm.moveUserName = this.auditInfo.moveUserName;
  },
  beforeDestroy() {
    Bus.$off("update");
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
  padding: 20px;
  overflow-y: auto;
  max-height: 500px !important;
}
</style>
